import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { tap, throwError } from 'rxjs';
import { AuthActions } from '../store/auth/auth.actions';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { NetworkLoggingService } from '../services/network-logging.service';
import { captureException } from "@sentry/angular";

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const store = inject(Store);
  const networkLoggingService = inject(NetworkLoggingService);

  const started = performance.now();

  return next(req).pipe(
    tap({
      next: () => checkSlowApi(req, started, false),
      error: () => checkSlowApi(req, started, true)
    }),
    catchError(err => {
      const duration = performance.now() - started;

      if (err.status === 401 && !err.url.includes('api/Messages')) {
        store.dispatch(AuthActions.clearCacheAndStore());
      }

      networkLoggingService.diagnoseError(req.url, err, duration);

      return throwError(err);
    })
  );
};

const slowApiIgnoreList = [
  'https://prod.ls-api.com/api/Contents/Binary'
];

function checkSlowApi(req: HttpRequest<any>, startTime: number, isError: boolean) {
  const end = performance.now();
  const duration = end - startTime;
  if (duration > 5000) {
    const isInIgnoreList = slowApiIgnoreList.some(url => req.url.includes(url));
    if (isInIgnoreList) {
      return;
    }

    const ex = new Error(`Slow API (ERROR > 5s): ${req.method} ${req.url} - ${duration.toFixed(0)}ms`);
    captureException(ex, {
      level: 'error',
      tags: {
        url: req.url,
        method: req.method,
        duration: duration.toFixed(0),
        type: 'slow-api',
        status: isError ? 'error' : 'success',
      }
    });
  }
}
